import React from 'react';

export default function SuccessIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="ic_success"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      width={props.width ?? '28'}
      height={props.height ?? '21'}
    >
      <circle id="BG" cx="14" cy="14" r="14" fill="#1aad7f" />
      <path
        id="Path_492"
        data-name="Path 492"
        d="M393.262,23.148l4.077,3.921,6.438-6.305"
        transform="translate(-384.52 -9.916)"
        fill="none"
        stroke={props.stroke ?? '#fff'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
